import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49f7901f"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"80px"} }, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "tel:06-42648564" }, " 06-42648564", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "KVK:"),
    /*#__PURE__*/_createTextVNode(" 80095305")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("b", null, "BTW:"),
    /*#__PURE__*/_createTextVNode(" NL003393490B83")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "https://www.linkedin.com/in/marianne-joosen-321b4a52/",
  target: "_blank"
}, " M. Joossen", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", null, [
      _createElementVNode("section", null, [
        _createElementVNode("div", null, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("p", null, [
                _createVNode(_component_font_awesome_icon, { icon: ['fas', 'phone'] }),
                _hoisted_2
              ])
            ])
          ]),
          _createElementVNode("ul", null, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("li", null, [
              _createElementVNode("p", null, [
                _createVNode(_component_font_awesome_icon, { icon: ['fab', 'linkedin'] }),
                _hoisted_5
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}